import { mapActions, mapGetters, mapMutations } from "vuex";
import questionText from "../../components/question-text/index.vue";

export default {
    name: "graduate-work-question",
    data() {
        return {
            answers: "",
            reInitComponents: false,
        };
    },
    components: {
        questionText,
    },
    created() {
        if (!this.currentItem) {
            this.fetchData({
                courseSlug: this.$route.params.item,
            }).then(() => {
                this.setData();
            });
        } else {
            this.setData();
        }
    },
    computed: {
        ...mapGetters({
            currentItem: "coursesGraduateWork/currentItem",
            isLoading: "coursesGraduateWork/isLoading",
        }),
    },
    methods: {
        ...mapActions({
            fetchData: "coursesGraduateWork/GET_LIST_ITEM",
            complete: "coursesGraduateWork/COMPLETE_TEST",
            startGraduateWork: "coursesGraduateWork/START_TEST",
        }),
        ...mapMutations({
            changeHeader: "coursesGraduateWork/CHANGE_HEADER",
            setCurrentQuestion: "coursesGraduateWork/SET_CURRENT_QUESTION",
        }),
        setData() {
            this.changeHeader({
                show: true,
                title: this.$t("graduateWork"),
            });

            if (this.currentItem.userGraduateWork.data.status === "on_checking") {
                this.$router.push({
                    name: "graduate-work-check",
                    params: {
                        graduateWorkId: this.$route.params.graduateWorkId,
                        item: this.$route.params.item,
                    },
                });
            } else if (
                this.currentItem.userGraduateWork.data.status === "failed" ||
                this.currentItem.userGraduateWork.data.status === "accepted"
            ) {
                this.$router.push({
                    name: "graduate-work-report",
                    params: {
                        graduateWorkId: this.$route.params.graduateWorkId,
                        item: this.$route.params.item,
                    },
                });
            } else {
                this.startGraduateWork({
                    courseSlug: this.$route.params.item,
                })
                    .then(() => {
                        if (this.currentItem.status === "") {
                            this.completeGraduateWork();
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 403) {
                            try {
                                this.$router.push({
                                    name: "graduate-work-check",
                                    params: {
                                        graduateWorkId: this.$route.params.graduateWorkId,
                                        item: this.$route.params.item,
                                    },
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    });
            }
        },
        updateQuestions(data) {
            this.answers = data;
        },
        createFormData() {
            const formData = new FormData();
            formData.append("graduateWorkId", this.$route.params.graduateWorkId);

            return formData;
        },
        completeGraduateWork() {
            const formData = new FormData();
            formData.append("courseSlug", this.$route.params.item);
            formData.append("graduateWorkId", this.$route.params.graduateWorkId);
            formData.append("answer", this.answers);
            formData.append("_method", "patch");
            this.complete(formData)
                .then((response) => {
                    if (response.status === "accepted" || response.status === "failed") {
                        try {
                            this.$router.push({
                                name: "graduate-work-report",
                                params: {
                                    graduateWorkId: this.$route.params.graduateWorkId,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    } else {
                        try {
                            this.$router.push({
                                name: "graduate-work-check",
                                params: {
                                    graduateWorkId: this.$route.params.graduateWorkId,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        const errors = error.response.data.validation;
                        for (let i in errors) {
                            this.$toasted.error(errors[i]);
                        }
                    }
                });
        },
        closeTest() {
            try {
                this.$router.push({
                    name: "courses-main",
                    params: { item: this.$route.params.item },
                });
            } catch (e) {
                console.log(e);
            }
            this.changeHeader({
                show: false,
                title: "",
            });
        },
    },
    destroyed() {
        this.setCurrentQuestion(null);
    },
};
